<form [formGroup]="paymentForm" (ngSubmit)="onSubmit()" novalidate>
	<div class="flex flex-col">
		<div class="mb-5">
			<label for="cbuNumber">Número de CBU</label>
			<div class="credit__card__number">
				<input 
					id="cbuNumber" 
					formControlName="cbuNumber" 
					type="text" 
					placeholder="1234 5678 9012 3456 7890 12"
					maxlength="27"
					class="input__base" 
					(input)="onCbuNumberInput($event)" 
					[ngClass]="{
						error:
							shouldShowError('cbuNumber', 'required') ||
							shouldShowError('cbuNumber', 'invalidCard') ||
							shouldShowError('cbuNumber', 'invalidFormat'),
					}" />
			</div>
			@if (shouldShowError('cbuNumber', 'required')) {
				<div class="error">El CBU es requerido.</div>
			}
			@if (shouldShowError('cbuNumber', 'invalidCard')) {
				<div class="error">El CBU debe tener exactamente 22 dígitos.</div>
			}
			@if (shouldShowError('cbuNumber', 'invalidFormat')) {
				<div class="error">Formato no válido. Solo se permiten números.</div>
			}
		</div>
	</div>

	<div class="mt-5">
		<activar-button
			text="Agregar CBU"
			loadingText="Agregando..."
			fill="solid"
			color="primary"
			type="submit"
			expand="full"
			[loading]="loading()"
			[disabled]="loading()" />
	</div>
</form>